function Logout({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      className={className}
    >
      <path
        d="M6.19254 23.9168C5.60318 23.9168 5.10433 23.7127 4.696 23.3043C4.28766 22.896 4.0835 22.3971 4.0835 21.8078V6.19254C4.0835 5.60318 4.28766 5.10433 4.696 4.696C5.10433 4.28766 5.60318 4.0835 6.19254 4.0835H14.0112V5.8335H6.19254C6.1027 5.8335 6.02045 5.87093 5.94579 5.94579C5.87093 6.02045 5.8335 6.1027 5.8335 6.19254V21.8078C5.8335 21.8976 5.87093 21.9799 5.94579 22.0545C6.02045 22.1294 6.1027 22.1668 6.19254 22.1668H14.0112V23.9168H6.19254ZM18.936 18.981L17.7245 17.7154L20.565 14.8752H10.6125V13.1252H20.565L17.7245 10.2849L18.936 9.01937L23.9168 14.0002L18.936 18.981Z"
        fill="#212121"
      />
    </svg>
  );
}

export default Logout;
